import { DataSource } from '@angular/cdk/collections';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { idx, ReservationStatusNameConstants } from '@uzurv/core';
import { UzurvFilterDefinition, UzurvTableColumnDefinition } from '@uzurv/http';
import { Observable, of } from 'rxjs';
import { GenericListButtonDefinition } from './generic-list-button/generic-list-button-definition';
import { GenericListIconDefinition } from './generic-list-icon';
import { GenericListIconButtonDefinition } from './generic-list-icon-button';
import { GenericListInputDefinition } from './generic-list-input/generic-list-input-definition';
import { GenericListLinkDefinition } from './generic-list-link';
import { GenericListMenuDefinition } from './generic-list-menu';
import { GenericListSelectDefinition } from './generic-list-select';
import { GenericListSlideToggleDefinition } from './generic-list-slide-toggle/generic-list-slide-toggle-definition';

export class GenericListDataSource extends DataSource<any> {
  private dataBase: any;
  constructor(data: Array<any>) {
    super();
    this.dataBase = data;
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<Array<any>> {
    const rows = [];
    if (this.dataBase) {
      this.dataBase.forEach(listItem => rows.push(listItem));
    }
    return of(rows);
  }
  disconnect() {}
}

@Component({
  selector: 'app-generic-list',
  templateUrl: './generic-list.component.html',
  styleUrls: ['./generic-list.component.scss']
})
export class GenericListComponent implements OnInit, OnChanges {
  @Input() testingIdAccessor: Array<string>;
  @Input() dataItems: Array<any> = [];
  @Input() columns: Array<UzurvTableColumnDefinition>;
  @Input() filtersEnabled = false;
  @Input() filtersTitle = '';
  @Input() filters: Array<UzurvFilterDefinition>;
  @Input() paginationEnabled = false;
  @Input() paginationLength = 10000;
  @Input() pageSizeOptions = [20, 30, 40];
  @Input() pageSize = 20;
  @Input() pageIndex = 0;
  @Input() allowsSelection = true;
  @Input() striped = false;
  @Input() paginationLocation = 'bottom';
  @Input() shouldShowLoader = false;
  @Input() enableInactiveShading = false;
  @Input() enableSelectedShading = false;
  @Input() enableStatusColors = false;
  @Input() enablePriorityColors = false;
  @Input() fixedHeader = false;
  @Input() menuButtonLabel = '...';

  @Output() filtersChangedHandler: EventEmitter<Array<UzurvFilterDefinition>> = new EventEmitter<Array<UzurvFilterDefinition>>();
  @Output() itemSelectedHandler: EventEmitter<any> = new EventEmitter<any>();
  @Output() paginationChangeHandler: EventEmitter<PageEvent> = new EventEmitter<PageEvent>();

  @ViewChild('loadingSpinner', { static: true }) loadingSpinner: MatProgressSpinner;

  dataSource: DataSource<any>;
  displayedColumns: Array<string>;

  reservationStatuses = ReservationStatusNameConstants;

  idx = idx;

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  ngOnInit() {
    this.displayedColumns = this.columns.map(c => c.columnDef);
    this.dataSource = new GenericListDataSource(this.dataItems);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.columns) {
      this.displayedColumns = this.columns.map(c => c.columnDef);
    }

    if (changes.dataItems) {
      this.dataSource = new GenericListDataSource(this.dataItems);
      this.changeDetectorRef.detectChanges();
    }
  }

  rowClicked(dataItem: any) {
    if (this.allowsSelection) {
      this.itemSelectedHandler.emit(dataItem);
    }
  }

  pageGenericList(pageEvent: PageEvent) {
    this.paginationChangeHandler.emit(pageEvent);
  }

  filtersChanged(event) {
    this.filtersChangedHandler.emit(event);
  }

  isButtonCell(dataItem: any): boolean {
    return dataItem instanceof GenericListButtonDefinition;
  }

  isIconButtonCell(dataItem: any): boolean {
    return dataItem instanceof GenericListIconButtonDefinition;
  }

  isSlideToggleCell(dataItem: any): boolean {
    return dataItem instanceof GenericListSlideToggleDefinition;
  }

  isIconCell(dataItem: any): boolean {
    return dataItem instanceof GenericListIconDefinition;
  }

  isSelectCell(dataItem: any): boolean {
    return dataItem instanceof GenericListSelectDefinition;
  }

  isMenuCell(dataItem: any): boolean {
    return dataItem instanceof GenericListMenuDefinition;
  }

  isLinkCell(dataItem: any): boolean {
    return dataItem instanceof GenericListLinkDefinition;
  }

  isInputCell(dataItem: any): boolean {
    return dataItem instanceof GenericListInputDefinition;
  }

  isHtmlCell(dataItem: any): boolean {
    return !(
      dataItem instanceof GenericListButtonDefinition ||
      dataItem instanceof GenericListIconButtonDefinition ||
      dataItem instanceof GenericListSlideToggleDefinition ||
      dataItem instanceof GenericListIconDefinition ||
      dataItem instanceof GenericListSelectDefinition ||
      dataItem instanceof GenericListMenuDefinition ||
      dataItem instanceof GenericListLinkDefinition ||
      dataItem instanceof GenericListInputDefinition
    );
  }
}
